export type FilterConditionDependencyResolverType =
  | 'clinicIds';

export type FilterConditionDependencyResolver = Partial<
  Record<
    FilterConditionDependencyResolverType,
    {
      resolve(params: any): Promise<any>;
    }
  >
>;

export abstract class AbstractFilterConditionDependencyResolver<T, K> {
  public abstract resolve(params: K): Promise<T>;
}
